export const getIsShowPopups = (state) => state.popups;